import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Phone, Mail, MapPin, Menu, X } from 'lucide-react';

export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  return (
    <header className="bg-white shadow-md sticky top-0 z-50">
      {/* Top Bar */}
      <div className="bg-blue-900 text-white py-2">
        <div className="container mx-auto px-4">
          <div className="flex flex-wrap justify-between items-center text-sm">
            <a href="mailto:contact@nhm-plomberie.fr" className="flex items-center gap-2 hover:text-blue-200 transition-colors">
              <Mail size={16} />
              <span>contact@nhm-plomberie.fr</span>
            </a>
            <a href="tel:0970705863" className="flex items-center gap-2 hover:text-blue-200 transition-colors">
              <Phone size={16} />
              <span>09 70 70 58 63</span>
            </a>
            <div className="flex items-center gap-2">
              <MapPin size={16} />
              <span>18 rue Legendre, 75017 Paris</span>
            </div>
          </div>
        </div>
      </div>

      {/* Main Navigation */}
      <nav className="container mx-auto px-4 py-4">
        <div className="flex justify-between items-center">
          <Link to="/" className="text-2xl font-bold text-blue-900">
            NHM Plomberie
          </Link>

          {/* Desktop Menu */}
          <div className="hidden md:flex gap-8">
            <Link
              to="/"
              className={`font-medium transition-colors hover:text-blue-600 ${
                isActive('/') ? 'text-blue-600' : 'text-gray-700'
              }`}
            >
              Accueil
            </Link>
            <Link
              to="/services"
              className={`font-medium transition-colors hover:text-blue-600 ${
                isActive('/services') ? 'text-blue-600' : 'text-gray-700'
              }`}
            >
              Services
            </Link>
            <Link
              to="/zone-intervention"
              className={`font-medium transition-colors hover:text-blue-600 ${
                isActive('/zone-intervention') ? 'text-blue-600' : 'text-gray-700'
              }`}
            >
              Zone d'intervention
            </Link>
            <Link
              to="/urgences"
              className={`font-medium transition-colors hover:text-blue-600 ${
                isActive('/urgences') ? 'text-blue-600' : 'text-gray-700'
              }`}
            >
              Urgences
            </Link>
            <Link
              to="/blog"
              className={`font-medium transition-colors hover:text-blue-600 ${
                isActive('/blog') || location.pathname.startsWith('/blog/') ? 'text-blue-600' : 'text-gray-700'
              }`}
            >
              Blog
            </Link>
            <Link
              to="/faq"
              className={`font-medium transition-colors hover:text-blue-600 ${
                isActive('/faq') ? 'text-blue-600' : 'text-gray-700'
              }`}
            >
              FAQ
            </Link>
            <Link
              to="/a-propos"
              className={`font-medium transition-colors hover:text-blue-600 ${
                isActive('/a-propos') ? 'text-blue-600' : 'text-gray-700'
              }`}
            >
              À propos
            </Link>
            <Link
              to="/contact"
              className={`font-medium transition-colors hover:text-blue-600 ${
                isActive('/contact') ? 'text-blue-600' : 'text-gray-700'
              }`}
            >
              Contact
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-blue-900"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label="Toggle menu"
          >
            {isMenuOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden mt-4 pb-4 flex flex-col gap-4">
            <Link
              to="/"
              className={`font-medium transition-colors hover:text-blue-600 ${
                isActive('/') ? 'text-blue-600' : 'text-gray-700'
              }`}
              onClick={() => setIsMenuOpen(false)}
            >
              Accueil
            </Link>
            <Link
              to="/services"
              className={`font-medium transition-colors hover:text-blue-600 ${
                isActive('/services') ? 'text-blue-600' : 'text-gray-700'
              }`}
              onClick={() => setIsMenuOpen(false)}
            >
              Services
            </Link>
            <Link
              to="/zone-intervention"
              className={`font-medium transition-colors hover:text-blue-600 ${
                isActive('/zone-intervention') ? 'text-blue-600' : 'text-gray-700'
              }`}
              onClick={() => setIsMenuOpen(false)}
            >
              Zone d'intervention
            </Link>
            <Link
              to="/urgences"
              className={`font-medium transition-colors hover:text-blue-600 ${
                isActive('/urgences') ? 'text-blue-600' : 'text-gray-700'
              }`}
              onClick={() => setIsMenuOpen(false)}
            >
              Urgences
            </Link>
            <Link
              to="/blog"
              className={`font-medium transition-colors hover:text-blue-600 ${
                isActive('/blog') || location.pathname.startsWith('/blog/') ? 'text-blue-600' : 'text-gray-700'
              }`}
              onClick={() => setIsMenuOpen(false)}
            >
              Blog
            </Link>
            <Link
              to="/faq"
              className={`font-medium transition-colors hover:text-blue-600 ${
                isActive('/faq') ? 'text-blue-600' : 'text-gray-700'
              }`}
              onClick={() => setIsMenuOpen(false)}
            >
              FAQ
            </Link>
            <Link
              to="/a-propos"
              className={`font-medium transition-colors hover:text-blue-600 ${
                isActive('/a-propos') ? 'text-blue-600' : 'text-gray-700'
              }`}
              onClick={() => setIsMenuOpen(false)}
            >
              À propos
            </Link>
            <Link
              to="/contact"
              className={`font-medium transition-colors hover:text-blue-600 ${
                isActive('/contact') ? 'text-blue-600' : 'text-gray-700'
              }`}
              onClick={() => setIsMenuOpen(false)}
            >
              Contact
            </Link>
          </div>
        )}
      </nav>
    </header>
  );
};